import React, { 
  // useContext, 
  // useState, 
  useEffect 
} from "react"
// import { Feats } from "../../utils/organism-formatting/feats"
// import { graphql } from "gatsby"

import FormatAndRenderFullBackgroundHero from "../../utils/organism-formatting/heroes/FormatAndRenderFullBackgroundHero"

import PageSections from "../PageSections/PageSections"
import "./ProductTemplateSections.scss"
import { InPageJumpNav, ProductSummary } from "terra-one"
import renderPaddingOrFullBleed from "../../utils/organism-formatting/renderPaddingOrFullBleed"
import PageSectionsAnchorWrapper from "../PageSections/PageSectionsAnchorWrapper"
import { useId } from "react"
// import { LayoutContext } from "../Layout/Layout"
import {
  formatPageLinks,
  updateDownloadLink,
} from "../../utils/organism-formatting/formatPageLinks"
import formatAndRenderInPageJumpNav from "../../utils/organism-formatting/InPageJumpNav/FormatAndRenderInPageJumpNav"
// import { formatImage } from "../../utils/organism-formatting/formatBaseMolecules"
import { createProductTrialPageLink } from "../../components/CTAButtons/CTAButtonsConnector"

// TODO - when regions are set up, we need to utilize regions from product and only render products in current region
const ProductTemplateSections = ({
  sections,
  locale,
  location,
  product,
  // rawLocale,
  // region,
  currentSpaceId,
  showJumpNav,
  products,
  siteIdentifier,
  setJumpNavItems,
  jumpNavItems,
  jumpNavTitle,
  jumpNavType,
}) => {
  const {
    flexArea,
    secondFlexArea,
    thirdSetOfFlexComponents,
    fourthSetOfFlexComponents,
    fifthSetOfFlexComponents,
    sixthSetOfFlexComponents,
    // productSku,
    productSummary,
    productHero,
    headerAndTextWithOptionalCta,
    headerAndTextWithOptionalCta2,
    headerAndTextWithOptionalCta3,
    headerAndTextWithSalesCta,
    superHeroWithVideo,
    headerWithText,
    iconMiniBlocks,
    twoByTwoWithTextAndImages,
    unboundedCardsSection,
    imageGallery,
    table,
    productPackage,
    boundedCardsSection,
    additionalProductInformation,
  } = sections || {}

  if (
    headerAndTextWithSalesCta &&
    headerAndTextWithSalesCta?.variant === "light"
  ) {
    headerAndTextWithSalesCta["className"] = "#F1F1F6"
  }

  if (headerAndTextWithSalesCta) {
    headerAndTextWithSalesCta["extraClass"] = "sales-cta grouped-component"
  }

  const firstFixedSection = [headerWithText, twoByTwoWithTextAndImages]

  const secondFixedSection = [
    headerAndTextWithOptionalCta,
    unboundedCardsSection,
  ]

  const thirdFixedSection = [imageGallery]

  const fourthFixedSection = [headerAndTextWithOptionalCta2, table]

  const fifthFixedSection = [
    productPackage,
    headerAndTextWithOptionalCta3,
    boundedCardsSection,
    iconMiniBlocks,
  ]

  const lastSection = [headerAndTextWithSalesCta]
  // const { homepageSlug } = useContext(LayoutContext)

  const superHero = overrideSuperHeroTheme(superHeroWithVideo)
  const renderRegionsForProductSummaryCard = (regionList, noRegionLabel) => {
    if (regionList && regionList?.length) {
      // removes a global region from rendering
      const removeGlobalFromGUI = regionList?.filter(reg => {
        return reg?.machineName?.toLowerCase() !== "global"
      })
      // this renders the rest of the regions
      if (removeGlobalFromGUI && removeGlobalFromGUI?.length) {
        return removeGlobalFromGUI.map(region => {
          return region?.name
        })
      } else {
        return ""
      }
    } else {
      return ""
    }
  }
  const renderProductSummary = (
    productSummary,
    product,
    additionalProductInformation,
    locale,
    currentSpaceId,
    siteIdentifier,
    homepageSlug
  ) => {
    const summaryCard = {
      // these fields have a fallback option if PIM is unavailable
      name: product?.node?.productName
        ? product?.node?.productName
        : additionalProductInformation?.productName
        ? additionalProductInformation?.productName
        : null,
      description: product?.node?.longDescription?.longDescription
        ? product?.node?.longDescription?.longDescription
        : additionalProductInformation?.longDescription?.longDescription
        ? additionalProductInformation?.longDescription?.longDescription
        : null,
      productLine: product?.node?.productLine
        ? product?.node?.productLine
        : additionalProductInformation?.productLine
        ? additionalProductInformation?.productLine
        : null,
      regions: product?.node?.regions
        ? renderRegionsForProductSummaryCard(
            product?.node?.regions,
            productSummary
          )
        : additionalProductInformation?.regions
        ? renderRegionsForProductSummaryCard(
            additionalProductInformation?.regions,
            productSummary
          )
        : "",
      cta: formatPageLinks(
        productSummary?.ctaForCard,
        locale,
        null,
        homepageSlug,
        currentSpaceId,
        products,
        siteIdentifier
      ),
    }

    const labels = {
      productSummaryLabel: productSummary?.productSummaryLabel,
      productLineLabel: productSummary?.productLineLabel,
      regionsLabel: productSummary?.regionsLabel,
      noRegionsLabel: productSummary?.noRegionsLabel,
    }
    const columnCard1 = {
      eyebrow: productSummary?.columnOneEyebrow,
      header: productSummary?.columnOneHeader,
      subheader: productSummary?.columnOneDescription,
      listType:
        productSummary?.columnOneBullets?.[0]?.__typename === "ContentfulPoint"
          ? "bullets"
          : productSummary?.columnOneBullets?.[0]?.__typename ===
            "ContentfulLink"
          ? "links"
          : null,
      list: formatList(
        productSummary?.columnOneBullets,
        locale,
        currentSpaceId,
        products,
        siteIdentifier,
        homepageSlug
      ),
    }

    const columnCard2 = {
      eyebrow: productSummary?.columnTwoEyebrow,
      header: productSummary?.columnTwoHeader,
      subheader: productSummary?.columnTwoDescription,
      listType:
        productSummary?.columnTwoBullets?.[0]?.__typename === "ContentfulPoint"
          ? "bullets"
          : productSummary?.columnTwoBullets?.[0]?.__typename ===
            "ContentfulLink"
          ? "links"
          : null,
      list: formatList(
        productSummary?.columnTwoBullets,
        locale,
        currentSpaceId,
        products,
        siteIdentifier,
        homepageSlug
      ),
    }

    const content = {
      theme: { backgroundColor: "#F1F1F6" },
      summaryCard,
      columns: [columnCard1, columnCard2],
      labels,
      version: product?.node?.version
        ? `${productSummary?.versionLabel}${product?.node?.version}`
        : additionalProductInformation?.version
        ? `${productSummary?.versionLabel}${additionalProductInformation?.version}`
        : null,
    }

    if (productSummary?.anchor && productSummary?.jumpNavTitle) {
      return (
        <PageSectionsAnchorWrapper
          key={`page-section-wrapper-summary`}
          children={renderPaddingOrFullBleed(
            <ProductSummary content={content} siteIdentifier={siteIdentifier} />
          )}
          anchor={productSummary?.anchor}
        />
      )
    }

    return renderPaddingOrFullBleed(
      <ProductSummary content={content} siteIdentifier={siteIdentifier} />
    )
  }

  const renderComponents = (
    components,
    flex,
    productInfo, // Corp ProductInfo Override
    additionalProductInformation, // Sector ProductInfo Override
    currentSpaceId,
    siteIdentifier,
    index=1000
  ) => {
    // we pass in "flex" for the "flex componentss"
    // some fixed components have certain rules and therefore passing productPage as a prop allows us to manipulate themes/variants without disruption
    if (!components) {
      return
    }
    components.filter(component => {
      if (component?.__typename === "ContentfulProductsPackage") {
        component["pimImage"] = productInfo?.node?.listImage
          ? productInfo?.node?.listImage
          : additionalProductInformation?.listImage
          ? additionalProductInformation?.listImage
          : null
      }
    })
    return (
      <PageSections
        pageSections={components}
        location={location}
        locale={locale}
        productPage={!flex ? true : false}
        currentSpaceId={currentSpaceId}
        products={products}
        siteIdentifier={siteIdentifier}
        parentIndex={index}
      />
    )
  }
  const firstHero = GetHero(
    productHero,
    locale,
    location,
    product, // Corp ProductInfo Override
    additionalProductInformation, // Sector ProductInfo Override
    currentSpaceId,
    products,
    siteIdentifier
  )

  const processJumpNavComponents = () => {
    const jumpNavComponents = [
      productHero,
      superHero,
      firstFixedSection,
      flexArea,
      secondFixedSection,
      secondFlexArea,
      thirdFixedSection,
      productSummary,
      fourthFixedSection,
      thirdSetOfFlexComponents,
      fifthFixedSection,
      fourthSetOfFlexComponents,
      fifthSetOfFlexComponents,
      sixthSetOfFlexComponents,
      lastSection,
    ]
    let formattedComponents = []
    jumpNavComponents?.forEach(component => {
      if (component && component != null) {
        if (Array.isArray(component)) {
          formattedComponents.push(...component)
        } else {
          formattedComponents.push(component)
        }
      }
    })
    return formattedComponents
  }

  useEffect(() => {
    setJumpNavItems(formatAndRenderInPageJumpNav(processJumpNavComponents()))
  }, [sections])

  return (
    <>
      <section className="product-template-sections" key={product?.node?.sku}>
        {firstHero}
        {superHero &&
          renderComponents(
            [superHero],
            null,
            null,
            null,
            currentSpaceId,
            siteIdentifier
          )}
        {firstFixedSection &&
          firstFixedSection.length &&
          renderComponents(
            firstFixedSection,
            null,
            product,
            additionalProductInformation,
            currentSpaceId
          )}
        {flexArea &&
          flexArea.length &&
          renderComponents(
            flexArea,
            "flex",
            null,
            null,
            currentSpaceId,
            siteIdentifier
          )}
        {secondFixedSection &&
          secondFixedSection.length &&
          renderComponents(
            secondFixedSection,
            null,
            product,
            additionalProductInformation,
            currentSpaceId
          )}
        {secondFlexArea &&
          secondFlexArea.length &&
          renderComponents(
            secondFlexArea,
            "flex",
            null,
            null,
            currentSpaceId,
            siteIdentifier
          )}
        {thirdFixedSection &&
          thirdFixedSection.length &&
          renderComponents(
            thirdFixedSection,
            null,
            product,
            additionalProductInformation,
            currentSpaceId,
            siteIdentifier
          )}
        {productSummary &&
          renderProductSummary(
            productSummary,
            product,
            additionalProductInformation,
            locale,
            currentSpaceId,
            siteIdentifier
          )}
        {fourthFixedSection &&
          fourthFixedSection.length &&
          renderComponents(
            fourthFixedSection,
            null,
            product,
            additionalProductInformation,
            currentSpaceId,
            siteIdentifier
          )}
        {thirdSetOfFlexComponents &&
          thirdSetOfFlexComponents.length &&
          renderComponents(
            thirdSetOfFlexComponents,
            "flex",
            null,
            null,
            currentSpaceId,
            siteIdentifier
          )}
        {fifthFixedSection &&
          fifthFixedSection.length &&
          renderComponents(
            fifthFixedSection,
            null,
            product,
            additionalProductInformation,
            currentSpaceId,
            siteIdentifier
          )}
        {fourthSetOfFlexComponents &&
          fourthSetOfFlexComponents.length &&
          renderComponents(
            fourthSetOfFlexComponents,
            "flex",
            null,
            null,
            currentSpaceId,
            siteIdentifier
          )}
        {fifthSetOfFlexComponents &&
          fifthSetOfFlexComponents.length &&
          renderComponents(
            fifthSetOfFlexComponents,
            "flex",
            null,
            null,
            currentSpaceId,
            siteIdentifier
          )}
        {sixthSetOfFlexComponents &&
          sixthSetOfFlexComponents.length &&
          renderComponents(
            sixthSetOfFlexComponents,
            "flex",
            null,
            null,
            currentSpaceId,
            siteIdentifier
          )}
        {lastSection &&
          lastSection.length &&
          renderComponents(
            lastSection,
            null,
            product,
            additionalProductInformation,
            currentSpaceId,
            siteIdentifier
          )}
      </section>
      {(showJumpNav && jumpNavType === "Vertical") && (
        <InPageJumpNav
          pageSections={jumpNavItems}
          jumpNavTitle={jumpNavTitle || "This Page"}
          jumpNavType={"vertical"}
        />
      )}
    </>
  )
}

const GetHero = (
  productHero,
  locale,
  location,
  product,
  additionalProductInformation,
  currentSpaceId,
  products,
  siteIdentifier
) => {
  const key = useId()
  const displayListImageInHero = additionalProductInformation?.displayListImage || false

  if (!productHero) {
    return <></>
  }

  if (product?.node?.backgroundImage) {
    // if corporate PIM exists, use it first.
    productHero["backgroundImage"] = product?.node?.backgroundImage
  } else if (additionalProductInformation?.backgroundImage) {
    // if sector PIM exists, use it next
    productHero["backgroundImage"] =
      additionalProductInformation?.backgroundImage
  }

  // update hero to image from PIM
  productHero.rightImage =
    displayListImageInHero === false
      ? null
      : product?.node?.listImage
      ? product?.node?.listImage
      : additionalProductInformation?.listImage
      ? additionalProductInformation.listImage
      : productHero?.rightImage
      ? productHero.rightImage
      : null
  if (productHero?.anchor && productHero?.jumpNavTitle) {
    return (
      <PageSectionsAnchorWrapper
        key={`product-hero-first`}
        children={
          <FormatAndRenderFullBackgroundHero
            key={key + 1}
            data={productHero}
            location={location}
            locale={locale}
            productPage={true}
            currentSpaceId={currentSpaceId}
            products={products}
            siteIdentifier={siteIdentifier}
          />
        }
        anchor={productHero?.anchor}
      />
    )
  }
  return (
    <FormatAndRenderFullBackgroundHero
      key={key}
      data={productHero}
      location={location}
      locale={locale}
      productPage={true}
      currentSpaceId={currentSpaceId}
      products={products}
      siteIdentifier={siteIdentifier}
    />
  )
}
const formatList = (
  list,
  locale,
  currentSpaceId,
  products,
  siteIdentifier,
  homepageSlug
) => {
  if (list && list.length) {
    if (list?.[0]?.__typename === "ContentfulPoint") {
      return list.map(item => {
        return { title: item?.header, text: item?.description }
      })
    }

    if (list?.[0]?.__typename === "ContentfulLink") {
      return list.map(link => {
        if (link?.linkToProductTrialPage?.reference?.urn) {
          return createProductTrialPageLink(
            locale,
            link,
          )
        }
        let linkText
        let prefix = ``

        const type = link?.url?.contentType
          ? link?.url?.contentType
          : link?.url?.internal?.type
          ? link?.url?.internal?.type
          : ""

        if (type && type === "article") {
          prefix = `articles/`
        } else if (type && type === "event") {
          prefix = `events/`
        } else if (type && type === "prose") {
          prefix = `prose/`
        } else if (type && type === "ContentfulNews") {
          prefix = `news/`
        } else if (
          type &&
          type === "ContentfulProductPage" &&
          !link?.url?.url?.includes("products/")
        ) {
          prefix = `products/`
        }

        if (link?.text) {
          linkText = link.text
        }

        if (!link?.text) {
          linkText = link?.url?.text
        }
        // const url = link?.internalLink ? link?.internalLink : link?.url?.url

        const destination =
          link?.url?.type && link?.url?.type === "ContentfulDownloadLink"
            ? updateDownloadLink(link?.url?.realLink?.url, currentSpaceId)
            : link?.url
            ? link?.url?.url?.startsWith("http")
              ? link?.url?.url
              : locale && typeof locale === "string"
              ? link?.url?.url === homepageSlug
                ? `/${locale?.toLowerCase()}/${prefix}`
                : `/${locale?.toLowerCase()}/${prefix}${link?.url?.url?.toLowerCase()}`
              : `/en/${prefix}${link?.url?.url?.toLowerCase()}`
            : link?.url === null && link?.internalLink
            ? `/${locale?.toLowerCase()}/${link?.internalLink}`
            : null

        return {
          url: destination,
          text: linkText,
          type:
            link?.url?.type && link?.url?.type === "ContentfulDownloadLink"
              ? "pdf"
              : null,
        }
      })
    }
  }
}

export const overrideSuperHeroTheme = hero => {
  if (!hero) {
    return
  }
  if (hero && hero?.colorScheme && hero?.colorScheme === "Dark Navy") {
    return hero
  } else {
    hero.colorScheme = "Dark Navy"
  }
  return hero
}

export default ProductTemplateSections
